import $axios from '@/utils/axios'

var host = process.env.NODE_API_HOST

export default {
    /**
     * 我的课程列表
     * 地址：/course/getMyCourseList
     * Authorization token信息
     * studentId  学生id
     */
    getWxPreAuthCode(data = {}) {
        return $axios({
            method:"post",
            url: `${host}/wechat/getWxPreAuthCode`,
            data
        })
    },
}